module.exports = Object.assign;